<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal
        :show.sync="modals.successModal"
        :message="message"
        :title="title"
      />
      <div class="row">
        <div class="col-lg"></div>

        <div class="col-lg-4">
          <card class="card-eprf" style="height: 630px">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  Terminated PTW <span style="color: #EC1B23;">*</span>
                </p>
              </div>
            </div>

            <p class="newtitle" v-if="displayflag">
              Choose File from Your Desktop
            </p>
            <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
              Please upload terminated PTW
            </p>
            <div class="fileinput" v-if="displayflag">
              <label
                for="terminate-upload"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>

              <div
                class="d-flex justify-content-center spinner"
                v-if="uploadload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="terminate-upload"
                type="file"
                ref="terminatedptw"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onTerminatedChange"
              />
            </div>
            <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
            <div v-if="uploadload == false" class="">
              <div
                v-for="(filee, index) in allTeminatedPTW"
                :key="index"
                class="row"
              >
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg text-left">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="displayflag">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeSignedDO(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg-4">
          <card class="card-eprf" style="height: 630px">
            <div class="row">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  LAB REPORT
                </p>
              </div>
            </div>

            <p class="newtitle" v-if="displayflag">
              Choose File from Your Desktop
            </p>
            <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
              Please upload lab report
            </p>
            <div class="fileinput" v-if="displayflag">
              <label
                for="lab-upload"
                type="primary"
                class="btn"
                style="
                  font-size: 13px;
                  color: #ffffff;
                  text-transform: capitalize;
                "
              >
                Choose File
              </label>

              <div
                class="d-flex justify-content-center spinner"
                v-if="labload == true"
              >
                <circle-8></circle-8>
              </div>

              <input
                accept="application/pdf"
                id="lab-upload"
                type="file"
                ref="signeddo"
                name="..."
                class="valid"
                :multiple="true"
                aria-invalid="false"
                style="display: none"
                v-on:change="onLabChange"
              />
            </div>
            <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
            <div v-if="labload == false" class="">
              <div
                v-for="(filee, index) in allLabReport"
                :key="index"
                class="row"
              >
                <div class="col-lg">
                  <div class="row">
                    <div class="col-lg text-left">
                      <a :href="filee.fileurl">
                        <base-button class="btn-link btn-primary">
                          {{ filee.filename }}
                        </base-button>
                      </a>
                    </div>
                    <div class="col-lg-4" v-if="displayflag">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeLab(filee.fileid)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
        </div>
        <div class="col-lg"></div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <base-button
            wide
            type="danger"
            @click.native="prevTab"
            class="btn-previous"
          >
            BACK
          </base-button>
          <base-button
            type="primary"
            wide
            class="btn-next"
            @click="submitdoc()"
             v-if="displayflag"
             :disabled="dis"
          >
            SUBMIT
          </base-button>
          <base-button
           v-if="!displayflag"
            type="primary"
            wide
            class="btn-next"
            @click="nextTab()"
          >
            NEXT
          </base-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle8 } from "vue-loading-spinner";
import StatusModal from "src/components/StatusModal.vue";
import swal from "sweetalert2";

export default {
  components: {
    Circle8,
    StatusModal,
  },
  data() {
    return {
      positionid: "",
      uploadload: false,
      allTeminatedPTW: [
        {
          fileid: "0",
          filename: "ABC File",
          fileurl: "",
        },
      ],
      allLabReport: [],
      labload: false,
      message: "",
      title: "",
      modals: {
        successModal: false,
      },
      status: "",
      displayflag:  false,
      dis: false
    };
  },
  methods: {
    submitdoc(){
      this.$http.post(":10001/api/v1/outgoing/waste/"+ this.$route.params.jobnum+"/terminate_ptw/submit").
      then(res => {
        if(!res.error){
          let response = res.message 
          console.log(response)
          this.nextTab()
        }
      })
    },
    onTerminatedChange(e) {
      this.uploadload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/"+ this.$route.params.jobnum+"/document/terminated-ptw",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.uploadload = false;
            this.getData();
          }
        });
    },
    onLabChange(e) {
      this.labload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/"+ this.$route.params.jobnum +"/document/lab-report",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.message = "Documents successfully uploaded";
            this.modals.successModal = true;
            this.labload = false;
            this.getData();
          }
        });
    },
    removeLab(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/"+ this.$route.params.jobnum+"/document/lab-report/"+ fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
                this.$refs.signeddo.value = ""

                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    removeSignedDO(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/"+ this.$route.params.jobnum+"/document/terminated-ptw/"+ fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.message = response;
                this.modals.successModal = true;
                this.$refs.terminatedptw.value = ""
                setTimeout(() => {
                  this.getData();
                }, 1000);
              }
            });
        }
      });
    },
    backtolist() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/product/" +
            this.$route.params.refno +
            "/terminate_ptw/submit"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            this.message = response;
            this.modals.successModal = true;
            console.log(response);

            setTimeout(() => {
              this.redirect()
            }, 1000)
           
          }
        });
    },
    redirect(){
      this.$router.push("/Outgoing");
    },
    prevTab() {
      let parameter = {
        step: "6",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "6",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    getData() {
      this.allTeminatedPTW = [];
      this.allLabReport = []
      
      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.status = response.status.status;
            // terminated PTW
            for (var i = 0; i < response.terminated_ptw_document.length; i++) {
              let obj = {
                fileid: response.terminated_ptw_document[i].document_id,
                filename: response.terminated_ptw_document[i].meta.filename,
                fileurl: response.terminated_ptw_document[i].url,
              };
              this.allTeminatedPTW.push(obj);
            }
            // lab report
            for (var i = 0; i < response.lab_report.length; i++) {
              let obj = {
                fileid: response.lab_report[i].document_id,
                filename: response.lab_report[i].meta.filename,
                fileurl: response.lab_report[i].url,
              };
              this.allLabReport.push(obj);
            }
          }
        });
    },
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.getData();
  },
  watch: {
    positionid(){
      if(this.positionid == 4 && this.status == 100){
        this.displayflag = false
      } else if(this.positionid == 4 && this.status != 100){
        this.displayflag = false
      } else if(this.positionid != 4 && this.status == 100){
        this.displayflag = false
      } else if (this.positionid != 4 && this.status != 100){
        this.displayflag = true
      }
    },
    status(){
      if(this.positionid == 4 && this.status == 100){
        this.displayflag = false
      } else if(this.positionid == 4 && this.status != 100){
        this.displayflag = false
      } else if(this.positionid != 4 && this.status == 100){
        this.displayflag = false
      } else if (this.positionid != 4 && this.status != 100){
        this.displayflag = true
      }
    },
    allTeminatedPTW(){
      if(this.allTeminatedPTW.length != 0){
        this.dis = false
      } else {
        this.dis = true
      }
    }
  }
};
</script>

<style scoped>
.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}
</style>
